module.exports = __webpack_public_path__ + "img/emoji-slightly-smiling-face.a405d638.svg";